import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuesax from 'vuesax'
// Tailwind
import './assets/css/tailwind.css'
// Animate On Scrool
import AOS from 'aos'
import 'aos/dist/aos.css'
// Smooth scroll
import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.config.productionTip = false
  Vue.use(Vuesax, {
    // options here
  })

new Vue({
  created(){
    AOS.init();
  },
  router,
  render: h => h(App)
}).$mount('#app')
